import ENFJ from "../mbti/ENFJ.jpg";
import ENFP from "../mbti/ENFP.jpg";
import ENTJ from "../mbti/ENTJ.jpg";
import ENTP from "../mbti/ENTP.jpg";
import ESFJ from "../mbti/ESFJ.jpg";
import ESFP from "../mbti/ESFP.jpg";
import ESTJ from "../mbti/ESTJ.jpg";
import ESTP from "../mbti/ESTP.jpg";
import INFJ from "../mbti/INFJ.jpg";
import INFP from "../mbti/INFP.jpg";
import INTJ from "../mbti/INTJ.jpg";
import INTP from "../mbti/INTP.jpg";
import ISFJ from "../mbti/ISFJ.jpg";
import ISFP from "../mbti/ISFP.jpg";
import ISTJ from "../mbti/ENFJ.jpg";
import ISTP from "../mbti/ISTP.jpg";

export const ResultData = [
  {
    id: 1,
    name: "엄격한 관리자",
    best: "ESTJ",
    desc: "현실적이고 조직적으로 일을 처리하며 책임감이 강한 유형",
    image: `${ESTJ}`,
  },
  {
    id: 2,
    name: "자유로운 영혼",
    best: "ESFP",
    desc: "분위기를 고조시키며 즉흥적인 즐거움을 추구하는 유형",
    image: `${ESFP}`,
  },
  {
    id: 3,
    name: "대담한 통솔자",
    best: "ENTJ",
    desc: "비전과 계획을 갖고 목표를 이루기 위해 지도력을 발휘하는 유형",
    image: `${ENTJ}`,
  },
  {
    id: 4,
    name: "논리적인 사색가",
    best: "INTP",
    desc: "논리적인 사고와 비판적인 분석을 추구하는 유형",
    image: `${INTP}`,
  },
  {
    id: 5,
    name: "논리적인 전략가",
    best: "INTJ",
    desc: "논리적이고 분석적인 사고를 가지며 비전을 추구하는 유형",
    image: `${INTJ}`,
  },
  {
    id: 6,
    name: "청렴결백한 관리자",
    best: "ISTJ",
    desc: "실질적이고 현실적으로 문제를 해결하며 질서와 규칙을 중요시하는 유형",
    image: `${ISTJ}`,
  },
  {
    id: 7,
    name: "모험을 즐기는 사업가",
    best: "ESTP",
    desc: "대담하고 적응력이 강한 유형",
    image: `${ESTP}`,
  },
  {
    id: 8,
    name: "열정적인 중재자",
    best: "INFP",
    desc: "이상적이고 감정적인 면이 강한 유형",
    image: `${INFP}`,
  },
  {
    id: 9,
    name: "호기심 많은 예술가",
    best: "ISFP",
    desc: "예술적인 성향과 감수성이 풍부한 유형",
    image: `${ISFP}`,
  },
  {
    id: 10,
    name: "용감한 수호자",
    best: "ISFJ",
    desc: "따뜻하고 관대하며 주변 사람들을 보살피고 지지해주는 유형",
    image: `${ISFJ}`,
  },
  {
    id: 11,
    name: "재기발랄한 활동가",
    best: "ENFP",
    desc: "열정적이고 창의적인 사고를 가지며 새로운 가능성을 탐구하는 유형",
    image: `${ENFP}`,
  },
  {
    id: 12,
    name: "선의의 조언가",
    best: "INFJ",
    desc: "직관적이고 이해심이 많으며, 타인의 감정에 민감한 유형",
    image: `${INFJ}`,
  },
  {
    id: 13,
    name: "사교적인 외교관",
    best: "ESFJ",
    desc: "사회적으로 적응이 잘되고 다른 사람들을 배려하는 유형",
    image: `${ESFJ}`,
  },
  {
    id: 14,
    name: "독창적인 발명가",
    best: "ENTP",
    desc: "창의적이고 논리적으로 문제를 해결하며 새로운 아이디어를 만들어내는 유형",
    image: `${ENTP}`,
  },
  {
    id: 15,
    name: "만능 재주꾼",
    best: "ISTP",
    desc: "뛰어난 기술과 능숙한 해결능력으로 문제를 해결하는 유형",
    image: `${ISTP}`,
  },
  {
    id: 16,
    name: "정의로운 사회운동가",
    best: "ENFJ",
    desc: "친절하고 사회적인 영향력을 행사하여 타인을 지원하는 유형",
    image: `${ENFJ}`,
  },
];
